import { toast } from 'react-toastify'
import { GENERICS as dict } from '@/resources/dict'

const defaultToastContentId = 'toastContent'

const showNetworkError = (status, contentId) => {
  const errorMessage = (
    <div id={contentId || defaultToastContentId}>
      <h3>{dict.errorTitle}</h3>
      <p>{dict.networkError[status]}</p>
    </div>
  )
  toast.error(errorMessage)
}

const showDefaultError = (networkError, contentId) => {
  if (!networkError) return

  let errorDescription = dict.errorDescription500
  if (networkError.status_code === 500) {
    errorDescription = dict.errorDescription500
  } else if (networkError.status_code === 401) {
    errorDescription = dict.errorDescription401
  } else if (networkError.status_code === 403) {
    errorDescription = dict.errorDescription403
  }
  const errorMessage = (
    <div data-testid={contentId || defaultToastContentId}>
      <h3>{dict.errorTitle}</h3>
      <p>{errorDescription}</p>
    </div>
  )
  toast.error(errorMessage)
}

const success = (message, config, contentId) => {
  const successMessage = (
    <div data-testid={contentId || defaultToastContentId}>
      <p>{message}</p>
    </div>
  )
  toast.success(successMessage, config)
}

const error = (message, config, contentId) => {
  const errorMessage = (
    <div data-testid={contentId || defaultToastContentId}>
      <h3>{dict.errorTitle}</h3>
      <p>{message}</p>
    </div>
  )
  toast.error(errorMessage, config)
}

const warning = (message, config, contentId) => {
  const warningMessage = (
    <div data-testid={contentId || defaultToastContentId}>
      <p>{message}</p>
    </div>
  )
  toast.warn(warningMessage, config)
}

export default {
  showNetworkError,
  showDefaultError,
  success,
  error,
  warning,
}
